import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

type RuleNames = | 'mainButton';

const PREFIX = 'KebabMenu';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>((theme: ITheme) => ({
  mainButton: {
    background: 'white',
    border: 'none',
    cursor: 'pointer',
  },
}), { name: PREFIX });
